<template>
  <div>
    <encabezado></encabezado>
    <breadcrum :titulo='titulo' :texto='texto'></breadcrum>
    <div style="padding-left: 20%; padding-right: 20%; margin-bottom: 10%;margin-top:10%; width:100%;">


        <v-tabs v-model="tabs" vertical color="black" >


            <table >
                <tr>
                    <td>
                        <div style="margin:10%;padding-right:10px">
                            <svg width="35" height="35" version="1.1" viewBox="0 0 1200 1200" xmlns="http://www.w3.org/2000/svg">
                                <g>
                                    <path d="m297.24 1032.4h605.53c56.859 0 102.94-46.078 102.94-102.94 0-174.94-141.84-316.78-316.78-316.78l-177.98-0.046875c-174.94 0-316.78 141.84-316.78 316.78 0 56.906 46.219 102.98 103.08 102.98z" />
                                    <path d="m780.89 333.89c16.219 99.891-51.609 194.02-151.55 210.24-99.891 16.219-194.02-51.656-210.19-151.55-16.219-99.891 51.609-194.02 151.5-210.24 99.891-16.219 194.02 51.656 210.24 151.55" />
                                </g>
                            </svg>
                        </div>
                    </td>

                    <td>
                        <div class="tituloTab">
                            <v-tab id="idTab1" @click="onTab1" style="margin-left: 0px; padding-left:0;">
                                <span class="e-n-tab-icon" id="idSpan1" style="font-family: Heebo; font-size: 18px; color: black; font-weight: normal; text-transform: capitalize; margin-left: 0px; padding-left: 5%;text-align: left ;display:inline-block; width:100%">
                                    Acceso
                                </span>

                            </v-tab>
                        </div>
                    </td>
                </tr>

            </table>




            <v-tab-item>
                <v-card flat style="margin-top: 0; margin-left: 10%">
                    <v-card-text>
                        <div class="row">
                            <div class="form-row">
                                <h2 class="title--l align-left" style="font-family: Heebo; font-size: 26px; color: black; font-weight: bold; ">Acceso Particulares</h2>
                                <h3 class="title--m align-left" style="font-family: Heebo; font-size: 18px; font-weight: normal; color: black ">
                                    Acceso usuarios registrados en el Servicio Técnico
                                </h3>
                                <h4 class="title--s align-left" style="font-family: Heebo; font-size: 16px; font-weight: normal; color: black ">
                                    Introduzca su email y contraseña
                                </h4>
                            </div>
                        </div>


                        <v-row>

                            <div class="form-row" style="padding-left: 0;margin-top:20px">                               
                                <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-60 elementor-field-required">
                                        <input id="form-field-company" style="color: #606060" v-model="login.email" maxlength="40" size="60" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Email ">
                                    </div>
                                </div>
                            </div>

                            <div class="form-row" style="padding-left: 0;">
                                <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                    <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-60 elementor-field-required">
                                        <input id="form-field-company" style="color: #606060" v-model="login.password" maxlength="40" size="60" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Clave ">
                                    </div>
                                </div>
                               
                            </div>

                            <div style="margin-top: 20px;padding-left:0;" class="zeleris-shipping-tracking-search-form-action elementor-col-30 zeleris-btn-black-green">
                                <button @click="acceder" style="font-family: Heebo;font-size:16px; height:30px;width:200px">
                                    Acceder
                                </button>
                            </div>



                        </v-row>

                        <v-row>
                            <v-col cols="6" offset="3">
                                <p class="title--xs clickable"
                                   v-on:click="setPasswordResend()"
                                   style="font-family: Heebo; font-weight: normal;color:black;margin-top:5px">
                                    ¿Ha olvidado la contraseña?
                                </p>
                            </v-col>
                        </v-row>

                        <v-row v-if="this.passwordResend">

                            <span class="text--s align-left" style="font-family: Heebo; font-weight: normal; font-size: 16px; color: black">
                                Introduzca su email y le enviaremos un correo para poder
                                modificar la contraseña
                            </span>
                            <!--<v-text-field v-model="emailResend"
                                      color="#9be51a"
                                      label="Correo electrónico (email)"></v-text-field>
                        <v-btn color="#9be51a" @click="recuperarPassword" block>Enviar</v-btn>-->

                            <br /><br />
                            <br /><br />



                                  <div class="form-row" style="padding-left: 0;">
                                      <div class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                          <div class="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-company elementor-col-60 elementor-field-required">
                                              <input id="form-field-company" style="color: #606060" v-model="emailResend" maxlength="40" size="60" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Email ">
                                          </div>
                                      </div>
                                     
                                  </div>

                            <div style="margin-top: 20px;padding-left:0;" class="zeleris-shipping-tracking-search-form-action elementor-col-30 zeleris-btn-black-green">
                                <button @click="recuperarPassword" style="font-family: Heebo;font-size:16px; height:30px;width:200px">
                                    Enviar
                                </button>
                            </div>


                        </v-row>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat style="margin-top: 0; margin-left: 10%">
                    <v-card-text>
                        <div class="row">
                            <div class="form-row" style="margin-top:10px">
                                <h3 class="title--m align-left" style="font-family: Heebo; font-weight: normal;color:black">
                                    Registro de usuarios en el Servicio Técnico
                                </h3>
                                <h4 class="title--s align-left" style="font-family: Heebo; font-weight: normal; color: black">
                                    Necesitamos que rellenes estos datos para poder realizar el
                                    registro
                                </h4>
                            </div>
                        </div>

                        <v-row>

                            <v-form v-model="formularioCorrecto">
                                <br /><br />
                                <br /><br />

                                <div class="form-row" style="padding-left: 0;">
                                    <div style="margin-top:2px" class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                        <div class="zeleris-shipping-tracking-search-form-input-container elementor-col-40">
                                            <input id="searchbox" style="color: black; border-color: black; font-size: 16px; width: 350px" v-model="credentials.nombre" size="50" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Nombre ">
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row" style="padding-left: 0;">
                                    <div style="margin-top:2px" class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                        <div class="zeleris-shipping-tracking-search-form-input-container elementor-col-40">
                                            <input id="searchbox" style="color: black; border-color: black; font-size: 16px; width: 350px" v-model="credentials.apellidos" size="50" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Apellidos ">
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row" style="padding-left: 0;">
                                    <div style="margin-top:2px" class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                        <div class="zeleris-shipping-tracking-search-form-input-container elementor-col-40">
                                            <input id="searchbox" style="color: black; border-color: black; font-size: 16px; width: 350px" v-model="credentials.mail" size="50" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Email ">
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row" style="padding-left: 0;">
                                    <div style="margin-top:2px" class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                        <div class="zeleris-shipping-tracking-search-form-input-container elementor-col-40">
                                            <input id="searchbox" style="color: black; border-color: black; font-size: 16px; width: 350px" v-model="credentials.nif" size="50" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="NIF/DNI/NIE ">
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row" style="padding-left: 0;">
                                    <div style="margin-top:2px" class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                        <div class="zeleris-shipping-tracking-search-form-input-container elementor-col-40">
                                            <input id="searchbox" style="color: black; border-color: black; font-size: 16px; width: 350px" v-model="credentials.phone" size="50" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Teléfono ">
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row" style="padding-left: 0;">
                                    <div style="margin-top:2px" class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                        <div class="zeleris-shipping-tracking-search-form-input-container elementor-col-40">
                                            <input id="searchbox" style="color: black; border-color: black; font-size: 16px; width: 350px" v-model="credentials.password" size="50" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Contraseña ">
                                        </div>
                                    </div>
                                </div>

                                <div class="form-row" style="padding-left: 0;">
                                    <div style="margin-top:2px" class="elementor-element elementor-element-8a91ce8 elementor-button-align-start zeleris-btn-black-green zeleris-form-style-1 elementor-widget elementor-widget-form" data-id="8a91ce8" data-element_type="widget" data-settings="{&quot;step_next_label&quot;:&quot;Siguiente&quot;,&quot;step_previous_label&quot;:&quot;Anterior&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}" data-widget_type="form.default">
                                        <div class="zeleris-shipping-tracking-search-form-input-container elementor-col-40">
                                            <input id="searchbox" style="color: black; border-color: black; font-size: 16px; width: 350px" v-model="credentials.password2" size="50" type="text" name="form_fields[company]" class="elementor-field elementor-size-sm  elementor-field-textual" placeholder="Repita contraseña ">
                                        </div>
                                    </div>
                                </div>



                                <p v-if="!checkPasswords" class="text--m" style="font-family: Heebo; font-weight: normal">
                                    Las contraseñas no coinciden
                                </p>
                                <v-checkbox v-model="credentials.movistar"
                                            color="#9be51a"
                                            label="Soy cliente Movistar"></v-checkbox>

                                <div style="margin-top: 2px;padding-left:0;" class="zeleris-shipping-tracking-search-form-action elementor-col-30 zeleris-btn-black-green">
                                    <button @click="registrarUsuario" ::disabled="!formRegistroCompletado" style="font-family: Heebo;font-size:16px; height:30px;width:200px">
                                        Registro
                                    </button>
                                </div>

                                <br />
                                <span class="caption text--s "
                                      style="font-family: Heebo; font-weight: bold">
                                    * Una vez acabado el registro recibirá un email a su
                                    correo electrónico con un enlace para validar el usuario
                                    que acaba de registrar.
                                </span>
                            </v-form>

                        </v-row>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs>
        <br /><br />
        <br /><br />
    </div>

        <pie></pie>
    </div>
</template>

<script>
export default {
  components: {
    modal: () => import("@/components/Dinamicos/modal"),
    encabezado: () => import("@/components/newEncabezado"),
        pie: () => import("@/components/newPie"),
        breadcrum: () => import("@/components/breadcrum"),
  },

  data: () => ({
      formularioCorrecto: false,
      name: 'particularCR',
      texto: '',
    titulo: 'Acceso Particulares',
    tabs: 0,
    cookies: true,
    modal: false,
    passwordResend: false,
    emailResend: "",
    login: {
      aplicationCode: "WSATT",
      email: "",
      password: "",
    },
    credentials: {
      aplicationCode: "WSATT",
      mail: "",
      nombre: "",
      apellidos: "",
      nif: "",
      phone: "",
      password: "",
      password2: "",
      movistar: false,
    },
    rules: {
      email: (value) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "E-mail invalido.";
      },
      nif: (value) => {
        const pattern = /^(([X-Zx-z]{1})([-]?)(\d{7})([-]?)([A-Za-z]{1}))|((\d{8})([-]?)([A-Za-z]{1}))$/;
        return pattern.test(value) || "NIF Invalido.";
      },
      telefono: (value) => {
        //const pattern = /^(([0-9]{3}-[0-9]{3}-[0-9]{4}))|(([0-9]{10}))$/;
        //return pattern.test(value) || "Teléfono Invalido.";
        return (!Number.isNaN(value) && value.toString().length == 9) || "Teléfono Invalido. Formato 9 dígitos númericos seguidos, sin espacios ni guiones.";
      },
    },
  }),
  computed: {
    checkPasswords() {
      return (
        this.credentials.password === "" ||
        this.credentials.password2 === "" ||
        this.credentials.password === this.credentials.password2
      );
    },
    formRegistroCompletado() {
      localStorage.setItem('registroRegistro', JSON.stringify(this.credentials));
      return (
        Object.values(this.credentials).every((c) => c !== "") &&
        this.credentials.password === this.credentials.password2 && this.formularioCorrecto
      );
    },
    color() {
      if (this.formRegistroCompletado) return "#C2E500";
      else return "grey lighten-2";
    },
        },
        mounted: function () {
            var tab1 = document.getElementById('idTab1');
            tab1.style.backgroundColor = '#9be51a';
            var span1 = document.getElementById('idSpan1');
            span1.style.fontWeight = "bold";
            span1.style.fontFamily = "Heebo";

        },
        methods: {
            onTab1() {
                var tab2 = document.getElementById('idTab2');
                tab2.style.backgroundColor = 'white';
                var span2 = document.getElementById('idSpan2');
                span2.style.fontWeight = "400";

                var tab1 = document.getElementById('idTab1');
                tab1.style.backgroundColor = '#9be51a';
                var span1 = document.getElementById('idSpan1');
                span1.style.fontWeight = "bold";
                span1.style.fontFamily = "Heebo";
            },

            onTab2() {
                var tab1 = document.getElementById('idTab1');
                tab1.style.backgroundColor = 'white';
                var span1 = document.getElementById('idSpan1');
                span1.style.fontWeight = "400";

                var tab2 = document.getElementById('idTab2');
                tab2.style.backgroundColor = '#9be51a';
                var span2 = document.getElementById('idSpan2');
                span2.style.fontWeight = "bold";
                span2.style.fontFamily = "Heebo";
            },

    ocultar() {
      this.modal = false;
    },
    acceder() {
      this.$API.loginCliente(this.login).then((response) => {
        if (response != "") {
          this.$bus.datosUsuario = response.datos;
          this.$bus.login = true;
          window.localStorage.clear();
          window.localStorage.setItem("login", this.$bus.login);
          window.localStorage.setItem("loginData", JSON.stringify(this.login));
          this.$router.push("/info-clientes");
        }
      });
    },
    registrarUsuario() {
      this.$API.registro(this.credentials).then((response) => {
        if (response.codigo === 0) {
          this.cardLogin = true;
          Object.keys(this.credentials).forEach(
            (c) => (this.credentials[c] = "")
          );
        }
      });
    },
    recuperarPassword() {
      let recuperarPasswordData = {
        email: this.emailResend,
      };
      this.$API.recuperarPassword(recuperarPasswordData).then((response) => {
        if (response.codigo === 0) {
          console.log("Comprobar correo");
        }
      });
    },
    setPasswordResend() {
      if (!this.passwordResend) this.passwordResend = true;
      else this.passwordResend = false;
    },
  },
  created() {
    if (this.$route.query.opcion == "registro") this.tabs = 1;
    if (this.$route.query.opcion == "login") this.tabs = 0;
    let localS = window.localStorage.getItem("registroRegistro");
    if (localS != null) this.credentials = JSON.parse(localS);
  },
};
</script>

<style>

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-regular.woff');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-bold.woff');
        font-weight: bold;
    }

    ::placeholder {
        font-family: Heebo;
        color: black;
        font-weight: normal
    }

.v-btn__content {
  font-size: 1.5rem;
}
.negrita {
  font-weight: bold;
}
   

    #searchbox:focus {
        border: 1px solid black;
        border-radius: 4px;
    }

    .tituloTab {
        border-bottom: 3px solid #9be51a;
        padding-bottom: 4%;
        padding-top: 2%;
        margin-left: 0;
        padding-left: 0;

    }

   
</style>